module.exports = __webpack_public_path__ + "static/media/code-commit.53263792.svg";